import { Component, EventEmitter, Input, OnInit, Output } from "@angular/core";
import * as _ from "underscore";

import { SessionService } from "./../../../common/services/session.service";
import { KaryakartaService } from "./../../../karyakarta/karyakartaService/api/karyakarta.service";
import { ComplaintService } from "./../../complaint-service/api/complaint.service";

@Component({
  selector: "app-karyakarta-reassign",
  templateUrl: "./karyakarta-reassign.component.html",
  styleUrls: ["./karyakarta-reassign.component.scss"],
})
export class KaryakartaReassignComponent implements OnInit {
  selectedKaryakarta: any;
  KaryakartaData: any;
  complainObj: any;
  _rowData: any;
  userInfo: any;

  @Output() dataUpdated = new EventEmitter<any>();

  @Input()
  set rowData(value) {
    this._rowData = value;
    if (this._rowData && this._rowData.karyaKarta) {
      this.selectedKaryakarta = this._rowData.karyaKarta;
    }
    if (this._rowData) {
      this.complainObj = this._rowData;
    }
  }
  get rowData() {
    return this._rowData;
  }

  constructor(
    private karyakartaService: KaryakartaService,
    private complaintService: ComplaintService,
    private ss: SessionService
  ) {}

  getKarayakartaList() {
    this.karyakartaService.getKaryakarta().subscribe((data) => {
      // this.setKaryakartaByRole(data);
      this.KaryakartaData = _.filter(
        data[0],
        function (e) {
          if (e.status) {
            return true;
          } else {
            false;
          }
        },
        this
      );
    });
  }
  removeKaryakarta(karyakartaForRemove: any) {
    this.selectedKaryakarta = this.selectedKaryakarta.filter(function (
      e,
      index,
      arr
    ) {
      return e.id != karyakartaForRemove.id;
    },
    this);
  }

  submitData() {
    this.complainObj.karyaKarta = this.selectedKaryakarta;
    this.complainObj.commentCreatedBy = this.userInfo.id;
    // if (this.selectedKaryakarta != undefined) {
    //   // this.selectedKaryakarta.forEach(element => {
    //   //   let d = { id: element.id };
    //   //   this.complainObj.karyaKarta.push(d);
    //   // });
    // }
    this.complaintService.createComplaintData(this.complainObj).subscribe(
      (res: any) => {
        res.isEdit = false;
        this.rowData = res;
        this._rowData = res;
        this.dataUpdated.emit(res);
      },
      (err) => {},
      () => {}
    );
  }
  cancel() {
    this.dataUpdated.emit({});
  }
  ngOnInit() {
    this.userInfo = this.ss.getUserInfo();
    this.getKarayakartaList();
  }
}
